import React, { useCallback, useMemo } from 'react'
import DivideMotorbikeSymbol from 'components/elements/symbols/DamagedPart/DivideMoterbikeSymbol'

import styled from 'styled-components'
import { VehiclePart } from '../../../../states/QnState'
import ItemLine from '../ItemLine'
import CheckItem from './CheckItem'

/** FourWheeledVehicleLineのpropsのtype定義 */
type DivideCarFourLineProps = {
  /** 選択中の破損個所 */
  selectedParts: Array<VehiclePart>
  /** チェック選択時のコールバック */
  toggleDamagedPart?: (value: VehiclePart) => void
}

/**
 * 四輪自動車の破損個所選択行
 * @param props
 * @returns
 */
const MotorbikeLine: React.FC<DivideCarFourLineProps> = (props) => {
  const { selectedParts, toggleDamagedPart } = props
  /**
   * 破損個所を押下したときのクリックイベント処理
   * @param value 破損箇所の場所
   */
  const handleCheckClick = useCallback(
    (value: VehiclePart) => {
      if (!toggleDamagedPart) {
        return
      }
      toggleDamagedPart(value)
    },
    [selectedParts]
  )

  /** 各タイヤの破損状態の初期値 */
  const initialPartsStatus = {
    front: false,
    rear: false,
    leftFront: false,
    rightFront: false,
    rightRear: false,
    leftRear: false,
    allFront: false,
    allRear: false,
  }

  /** 各タイヤの破損状態をフラグ値で持つ */
  const partsStatus: Record<VehiclePart, boolean> = useMemo(() => {
    const updateDamageParts =
      selectedParts.length > 0 &&
      selectedParts.map((parts) => {
        return { [parts]: true }
      })
    return updateDamageParts
      ? Object.assign({}, initialPartsStatus, ...updateDamageParts)
      : initialPartsStatus
  }, [selectedParts])

  return (
    <ItemLine variableHeight showLineBorder>
      <InnerContainer>
        <SymbolArea>
          <DivideMotorbikeSymbol />
        </SymbolArea>
        <CheckOverlayArea>
          <BoxOverlay isDamaged={partsStatus.front} />
          <BoxOverlay isDamaged={partsStatus.rear} />
        </CheckOverlayArea>
        <CheckOverlayArea>
          <CheckOverlayWrapper>
            <CheckItem
              isChecked={partsStatus.front}
              onClick={(): void => {
                handleCheckClick('front')
              }}
              marginLeft="5%"
              marginRight="auto"
            />
          </CheckOverlayWrapper>
          <CheckOverlayWrapper isBack={true}>
            <CheckItem
              isChecked={partsStatus.rear}
              onClick={(): void => {
                handleCheckClick('rear')
              }}
              marginLeft="auto"
              marginRight="5%"
            />
          </CheckOverlayWrapper>
        </CheckOverlayArea>
      </InnerContainer>
    </ItemLine>
  )
}

export default MotorbikeLine

const InnerContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 640px;
  height: 100%;
  margin: 0 auto;
`

const SymbolArea = styled.div`
  margin: 32px 16px;
`

const CheckOverlayArea = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  bottom: 16px;
  left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const BoxOverlay = styled.div<{
  isDamaged: boolean
}>`
  position: relative;
  width: 40%;
  height: 100%;
  background: ${(props): string =>
    props.isDamaged ? 'var(--color-main)' : 'transparent'};
  opacity: 0.16;
`

const CheckOverlayWrapper = styled.div<{ isBack?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props): string =>
    props.isBack ? 'flex-end' : 'flex-start'};
  width: 40%;
  height: 100%;
`
